<template>
    <!-- eslint-disable vue/no-custom-modifiers-on-v-model -->
    <vc-date-picker
        v-model.range.string="range"
        :masks="masks"
        :locale="$i18n.locale"
        :min-date="disableMinStartDate ? null : minStartDate"
        :max-date="maxEndDate"
        :columns="$breakpoint.smAndDown ? 1 : 2"
        :rows="1"
        :popover="popover"
        :first-day-of-week="$conf.public.firstDayOfWeek || undefined"
        @dayclick="dayclick"
        @popover-will-show="popoverWillShow"
    >
        <template v-slot="{inputEvents}">
            <div v-on="inputEvents.start">
                <v-text-field
                    :class="textFieldClass"
                    :label="$t('supplier.dates_range')"
                    readonly
                    :single-line="singleLine"
                    hide-details
                    :bg-color="color || 'white'"
                    :prepend-inner-icon="showIcon ? 'mdi-calendar' : null"
                    :model-value="formattedDate"
                />
            </div>
        </template>
    </vc-date-picker>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {DaterangeM} from '~/components/search/forms/DaterangeM.vue'

    @Component
    export class DateRangeMExtended extends DaterangeM {
        @Prop({default: false}) disableMinStartDate
        @Prop({default: ''}) color
    }

    export default DateRangeMExtended
</script>

<style scoped lang="scss">
    :deep(.date-range-input) {
        @media (min-width: 961px) and (max-width: 1635px) {
            input {
                font-size: 16px;
            }
        }
    }
</style>
